import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
//import styles from "./styles"
import { isEmpty, camelCase } from "lodash"
import update from "immutability-helper"

import packageJson from "../../package.json"
import { login, register, sendPin } from "../actions/authentication"
import { setVisibility } from "../actions/message-drawer"
import { toggleProfileDialog } from "../actions/users"
import { openSnackBar } from "../actions/snack-bar"
import { switchActiveCompany } from "../actions/companies"
import PhoneInput from "../components/PhoneInput/index"
import widthWidth from "@material-ui/core/withWidth"
import { getCurrentHost } from "../utils/getHost"
const { version } = packageJson

let duration = 150

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loginPhone: "",
      loginPassword: "",
      registerFirstName: "",
      registerLastName: "",
      registerEmail: "",
      registerPhone: "",
      registerPassword: "",
      registerCountry: "US",
      forms: {},
      isRegister: false,
      isPin: false,
      pinSent: false,
      pin: ["", "", "", ""],
      delay: "register",
      agreedToTerms: false,
    }
  }
  componentDidMount() {
    this.setUpForms()
    if (
      getCurrentHost() === "crewmama" &&
      this.props.history.location.pathname.includes("register")
    ) {
      this.toggleRegister()
    }
    this.props.dispatch(setVisibility(false))
    if (!isEmpty(this.props.authentication.authenticatedUser)) {
      // debugger;
      // Trying to skip checks in update_events.js but it brings me here
      //this.props.history.push(`/crew`)
    }
  }
  componentWillUnmount() {
    this.props.dispatch(setVisibility(true))
  }
  setUpForms = () => {
    const forms = document.querySelectorAll("form")
    forms.forEach(form => {
      const formName = camelCase(form.id)
      const inputs = form.getElementsByTagName("input")
      let newState = update(this.state, {})
      if (!newState.forms[formName]) {
        newState.forms[formName] = {}
      }
      for (let i = 0; i < inputs.length; ++i) {
        newState.forms[formName][inputs[i].name] = {
          validity: inputs[i].validity,
        }
      }
      newState.forms[formName].valid = this.formIsValid(
        newState.forms[formName]
      )
      this.setState(newState)
    })
  }
  clearForms = () => {
    this.setState({
      loginPhone: "",
      loginPassword: "",
      registerFirstName: "",
      registerLastName: "",
      registerEmail: "",
      registerPhone: "",
      registerPassword: "",
      agreedToTerms: false,
      forms: {},
    })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity
    const formName = camelCase(e.target.form.id)

    let newState = update(this.state, {
      [fieldName]: { $set: value },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: { $set: validity },
          },
        },
      },
    })
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName])
    this.setState(newState)
  }
  onRegisterPhoneCountryChange = country => {
    this.setState({ registerCountry: country })
  }
  handlePhoneInputChange = (formName, fieldName, value) => {
    const validity = document.getElementById(fieldName).validity
    let newState = update(this.state, {
      [fieldName]: { $set: value },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: { $set: validity },
          },
        },
      },
    })
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName])
    this.setState(newState)
  }
  handleInputBlur = e => {
    const fieldName = e.target.name

    let newState = update(this.state, {
      forms: {
        [camelCase(e.target.form.id)]: {
          [fieldName]: {
            touched: { $set: true },
          },
        },
      },
    })
    this.setState(newState)
  }
  fieldIsValid = (inputName, formName) => {
    if (!isEmpty(this.state.forms[formName])) {
      if (this.state.forms[formName][inputName].touched) {
        return this.state.forms[formName][inputName].validity.valid
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  afterLogin = response => {
    if (
      this.props.location.state &&
      this.props.location.state.hasOwnProperty("redirect")
    ) {
      this.props.history.push(this.props.location.state.redirect)
    } else {
      //this.props.history.push(`/crew`)
    }
    if (response.roles.length === 0) {
      this.props.dispatch(toggleProfileDialog(true, response))
    }
    if (response.companies.length === 1) {
      this.props.dispatch(
        switchActiveCompany(
          response.companies[0].id,
          response.companies[0].managers.find(m => m.id === response.id) ? 1 : 2
        )
      )
    }
    if (!response.has_password) {
      this.props.dispatch(
        openSnackBar({
          message: "Please enter a password to make login easier in the future",
        })
      )
    }
  }
  doLogin = e => {
    e.preventDefault()
    const { loginPhone: phone, loginPassword: password } = this.state
    this.props
      .dispatch(login({ phone, password }))
      .then(response => {
        this.afterLogin(response)
      })
      .catch(err => {
        let message = "There was an error logging in"
        if (err.type === "not found") {
          message = "Account not found"
        } else if (err.type === "pass") {
          message = "Password was incorrect"
        } else if (err.message === "Missing credentials") {
          message = "Use 'Forgot Login' to login and set a password"
        }
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
      })
  }
  doRegister = e => {
    e.preventDefault()
    const {
      registerPhone: phone,
      registerPassword: password,
      registerFirstName: first_name,
      registerLastName: last_name,
      registerEmail: email,
    } = this.state
    if (this.state.agreedToTerms) {
      return this.props
        .dispatch(
          register({
            phone,
            password,
            first_name,
            last_name,
            email,
            countryCode: this.state.registerCountry,
          })
        )
        .then(response => {
          this.afterLogin(response)
        })
        .catch(err => {
          let message = "There was an error with your registration"
          if (err.message === "User creation error") {
            if (err.error.code === "ER_DUP_ENTRY") {
              if (err.error.sqlMessage.indexOf("for key 'phone'") > -1) {
                message = "That phone number is already in our system"
              }
            }
          }
          this.props.dispatch(
            openSnackBar({
              message,
            })
          )
        })
    } else {
      return this.props.dispatch(
        openSnackBar({
          message: "You must agree to the privacy policy to register",
        })
      )
    }
  }
  toggleRegister = () => {
    let delay
    if (this.state.isRegister) {
      delay = "login"
    } else {
      delay = "register"
    }
    this.setState({
      isRegister: !this.state.isRegister,
      delay,
    })
    setTimeout(() => {
      if (!this.state.forms.hasOwnProperty("registerForm")) {
        this.setUpForms()
      }
    }, duration + 100)
  }
  getDelay = formName => {
    return this.state.delay === formName ? duration + 100 : 0
  }
  forgotLogin = () => {
    if (this.state.loginPhone) {
      this.props.dispatch(sendPin(this.state.loginPhone))
      this.setState({ isPin: true, pinSent: true })
    } else {
      this.setState({ isPin: true })
    }
    setTimeout(() => {
      if (!this.state.forms.hasOwnProperty("pinForm")) {
        this.setUpForms()
      }
    }, 230)
  }
  handlePinInputChange = e => {
    const index = parseInt(e.target.name, 10)
    const value = e.target.value
    if (value.length <= 1) {
      let arr = this.state.pin
      arr.splice(index, 1, value)
      this.setState(
        update(this.state, {
          pin: {
            $set: arr,
          },
        })
      )
      if (value) {
        const nextInput = document.getElementById(`pinInput${index + 1}`)
        if (nextInput) {
          nextInput.focus()
        }
      }
    }
  }
  handlePinKeyPress = e => {
    const index = parseInt(e.target.name, 10)
    if (e.keyCode === 8 && this.state.pin[index] === "") {
      const prevInput = document.getElementById(`pinInput${index - 1}`)
      if (prevInput) {
        prevInput.focus()
      }
    }
  }
  resendPin = () => {
    this.props.dispatch(sendPin(this.state.loginPhone)).then(() => {
      this.props.dispatch(
        openSnackBar({
          message: "Pin number resent",
        })
      )
    })
  }
  handlePin = e => {
    e.preventDefault()
    this.setState({ sendingPin: true })
    if (this.state.pinSent) {
      this.props
        .dispatch(
          login({
            phone: this.state.loginPhone,
            auth_code: this.state.pin.join(""),
          })
        )
        .then(res => {
          this.setState({ sendingPin: false })
          this.afterLogin(res)
        })
        .catch(err => {
          this.props.dispatch(
            openSnackBar({
              message: "Pin number was incorrect",
            })
          )
          this.setState({ sendingPin: false })
        })
    } else {
      this.props
        .dispatch(sendPin(this.state.loginPhone))
        .then(() => {
          this.setState({ sendingPin: false, pinSent: true })
        })
        .catch(err => {
          if (err.message.indexOf("for user id #null") > -1) {
            this.props.dispatch(
              openSnackBar({
                message: "No account with that number found",
              })
            )
          } else if (err.message.indexOf("No outgoing SMS number") > -1) {
            this.props.dispatch(
              openSnackBar({
                message: "Could not text pin number",
              })
            )
          } else {
            this.props.dispatch(
              openSnackBar({
                message: "There was an error texting pin number",
              })
            )
          }
        })
    }
  }

  handleCheckbox = name => event => {
    this.setState({ ...this.state, [name]: event.target.checked })
  }

  goToHomesite = () => {
    if (getCurrentHost() === "crewmama") {
      window.location.href = "https://crewmama.com/"
    } else {
      window.location.href = "/"
    }
  }

  render() {
    // duration = this.props.theme.transitions.duration.shorter
    return (
      <div>
        You have disconnected your Quickbooks Online company. Please contact
        accounting@gototeam.com to reconnect.
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
  }
}

export default compose(
  connect(mapStateToProps),
  //withStyles(styles),
  widthWidth()
)(Login)
